import React, { PropTypes } from 'react/addons';
import cx from 'classnames';
import $ from 'jquery';

import createPortal from './createPortal';

const Modal = React.createClass({
  propTypes: {
    closing: PropTypes.bool,
    noAnimation: PropTypes.bool,

    className: PropTypes.string,
    modalStyle: PropTypes.object,

    children: PropTypes.any.isRequired,

    onRequestClose: PropTypes.func.isRequired,
  },

  getInitialState() {
    return {
      opened: false,
      modalStyle: {},
    };
  },

  /* eslint-disable react/no-did-mount-set-state */
  componentDidMount() {
    // Make sure the initial state is applied.
    /* eslint-disable no-unused-expressions */
    window.getComputedStyle(this.getDOMNode()).opacity;
    /* eslint-enable no-unused-expressions */

    this.setState({
      opened: true
    });
    $('html, body').addClass('has-open-modal');
  },
  /* eslint-enable react/no-did-mount-set-state */

  componentWillUnmount() {
    $('html, body').removeClass('has-open-modal');
  },

  render() {
    const { children, closing, noAnimation, className, modalStyle, onRequestClose, ...rest } = this.props;
    const { opened } = this.state;

    const modalWrapperClasses = {
      'ofs-Modal__Wrapper': true,
      'u-no-transition': noAnimation,
    };

    const modalOverlayClasses = {
      'ofs-ModalOverlay': true,
      'u-no-transition': noAnimation,
    };

    const modalClasses = {
      'ofs-Modal': true,
      'u-no-transition': noAnimation,
    };
    if (className) {
      modalClasses[className] = true;
    }

    const opacity = noAnimation || (opened && !closing) ? 1 : 0;

    return (
      <div className={cx(modalWrapperClasses)} style={{ opacity }} onClick={onRequestClose}>
        <div className={cx(modalOverlayClasses)} style={{ opacity }}></div>
        <div ref="modal" role="dialog" style={Object.assign({}, { opacity }, modalStyle)}
          className={cx(modalClasses)}
          onClick={(event) => event.stopPropagation()} {...rest}>
          {children}
        </div>
      </div>
    );
  }
});

export default createPortal(Modal);



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/components/layers/ModalNext.jsx
 **/